function animateTimelineSimple() {
  document.querySelectorAll('.timeline-step-simple').forEach((step, i) => {
    setTimeout(() => step.classList.add('show'), 80 + i * 100);
  });
  document.querySelectorAll('.timeline-connector-simple').forEach((conn, i) => {
    setTimeout(() => conn.classList.add('fill'), 120 + i * 100);
  });
}

if (window.Turbo) {
  document.addEventListener('turbo:load', () => requestAnimationFrame(animateTimelineSimple));
}
document.addEventListener('DOMContentLoaded', () => requestAnimationFrame(animateTimelineSimple));
